<template>
  <div class="search-box">
    <a-form class="form-box">
      <!-- <a-form-item>
      <template #label>
        <span>商品名称</span>
      </template>
      <a-input v-model:value="params.keywords" placeholder="请输入商品名称" allowClear style="width: 155px" />
    </a-form-item> -->
      <a-form-item>
        <template #label>
          <span>商品SPU</span>
        </template>
        <a-input v-model:value="params.SPU" placeholder="请输入商品SPU" allowClear style="width: 155px" />
      </a-form-item>
      <a-form-item>
        <template #label>
          <span>支付宝商品ID</span>
        </template>
        <a-input v-model:value="params.goodsId" placeholder="请输入支付宝商品ID" allowClear style="width: 155px" />
      </a-form-item>

      <a-form-item>
        <a-space>
          <a-button type="primary" @click="sendData('search')">
            <SearchOutlined />
            搜索
          </a-button>
        </a-space>
      </a-form-item>
      <a-form-item>
        <a-space>
          <slot></slot>
        </a-space>
      </a-form-item>
    </a-form>
    <div style="display: flex">
      <a-space>
        <slot name="searchRight"></slot>
      </a-space>
    </div>
  </div>
</template>
<script>
import { SearchOutlined } from "@ant-design/icons-vue";

export default {
  props: {
    searchType: {
      type: String,
      default() {
        return "copyHome"; //copyHome copyTask
      },
    },
  },
  components: { SearchOutlined },
  data() {
    return {
      params: { keywords: "", goodsId: "" },
    };
  },

  methods: {
    //查询
    sendData(type) {
      if (type === "reset") this.params = { type: 5 };
      this.$emit("search", { params: this.params });
    },
    //清空
    clear() {
      this.params = { keywords: "", goodsId: "" };
    },
  },
};
</script>
<style scoped lang="less">
@import "./index";
</style>
